import GroupsBlue from '@web/assets/svg/Icons/32/groups-blue.svg';
import {
  ConversationLayout,
  ConversationLayoutFooter,
  ConversationLayoutHeader,
  ConversationLayoutMain,
  ConversationLayoutSidebar,
} from '@web/conversations/Conversation/ConversationLayout/ConversationLayout';
import {
  IconWrapper,
  Name,
  Wrapper,
} from '@web/conversations/Conversation/ConversationHeader/conversationHeader.styles';

import { DateSkeleton } from './components/DateSkeleton';
import { EditorSkeleton } from './components/EditorSkeleton';
import { MembersSkeleton } from './components/MembersSkeleton';
import { MessageSkeleton } from './components/MessageSkeleton';
import { ListWrapper } from './conversationSkeleton.styles';

type Props = {
  name: string;
};

export const ConversationSkeleton = ({ name }: Props) => (
  <ConversationLayout>
    <ConversationLayoutHeader>
      <Wrapper>
        <IconWrapper>
          <GroupsBlue />
        </IconWrapper>
        <Name>{name}</Name>
      </Wrapper>
    </ConversationLayoutHeader>

    <ConversationLayoutMain>
      <ListWrapper>
        <MessageSkeleton />
        <MessageSkeleton alternative />
        <DateSkeleton />
        <MessageSkeleton />
        <MessageSkeleton alternative />
        <MessageSkeleton />
      </ListWrapper>
    </ConversationLayoutMain>

    <ConversationLayoutSidebar>
      <MembersSkeleton />
    </ConversationLayoutSidebar>

    <ConversationLayoutFooter>
      <EditorSkeleton />
    </ConversationLayoutFooter>
  </ConversationLayout>
);
